import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { makeStyles } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Accordion, AccordionSummary, AccordionDetails, Grid, Typography } from '@material-ui/core';
import { fetchEfectorHorariosPorProfesional } from '../../../actions/turnos/efectorHorarios';
import { fetchlicenciasProfesionales } from '../../../actions/turnos/licenciasProfesionales';
import { HorariosProfesional } from './HorariosProfesional';
import { LicenciasProfesional } from './LicenciasProfesional';

const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
}));
  
export const HorariosLicenciasProfesional = ({title, idProfesional}) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { items: licenciasItems } = useSelector((state) => state.licenciasProfesionales);
    const { items: horariosItems } = useSelector((state) => state.efectorHorarios);

    const [ horariosVigentes, setHorariosVigentes ] = useState([]);
    const [ horariosProximos, setHorariosProximos ] = useState([]);
    const [ licenciasActFut, setLicenciasActFut ] = useState([]);

    useEffect(() => {
        if(idProfesional && idProfesional !== -1){
          dispatch( fetchEfectorHorariosPorProfesional(idProfesional) );
          dispatch( fetchlicenciasProfesionales(null, idProfesional, null) );
        }
    }, [dispatch, idProfesional]);

    useEffect(() => {
        setHorariosVigentes(horariosItems.filter(s => !s.inHabilitado).filter(s => moment(moment().format('YYYY-MM-DD')).isBetween(moment(s.fechaInicio).format('YYYY-MM-DD'), moment(s.fechaFin).format('YYYY-MM-DD'), undefined, '[]')));
        setHorariosProximos(horariosItems.filter(s => !s.inHabilitado).filter(s => moment(moment(s.fechaInicio).format('YYYY-MM-DD')).isAfter(moment(moment().format('YYYY-MM-DD')))));
      }, [horariosItems]);
    
    useEffect(() => {
        setLicenciasActFut([
            ...licenciasItems.filter(s => !s.idUsuarioBaja).filter(s => moment(moment().format('YYYY-MM-DD')).isBetween(moment(s.fechaDesde).format('YYYY-MM-DD'), moment(s.fechaHasta).format('YYYY-MM-DD'), undefined, '[]')),
            ...licenciasItems.filter(s => !s.idUsuarioBaja).filter(s => moment(moment(s.fechaDesde).format('YYYY-MM-DD')).isAfter(moment(moment().format('YYYY-MM-DD'))))
        ])
    }, [licenciasItems]);
    
    return ( 
        <div className={classes.root}>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography className={classes.heading}>{title}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container justify="center" spacing={1}>  
                        {horariosVigentes.length>0&&
                            <Grid item xs={12} style={{marginTop:-15}}>
                                <Grid container direction="row" alignItems="center">
                                    <HorariosProfesional 
                                        title={'Horarios Vigentes'}
                                        items={horariosVigentes} 
                                    />
                                </Grid>
                            </Grid>
                        }
                        {horariosProximos.length>0&&
                            <Grid item xs={12}>
                                <Grid container direction="row" alignItems="center">
                                    <HorariosProfesional 
                                        title={'Proximos Horarios'}
                                        items={horariosProximos} 
                                    />
                                </Grid>
                            </Grid>
                        }
                        {licenciasActFut.length>0&&
                            <Grid item xs={12}>
                                <Grid container direction="row" alignItems="center">
                                    <LicenciasProfesional 
                                        title={'Licencias actuales y futuras'}
                                        items={licenciasActFut} 
                                    />
                                </Grid>
                            </Grid>
                        }
                    </Grid>
                </AccordionDetails>
            </Accordion>
            
        </div>
     );
}